export const modalDescriptions = {
  airport: {
    title: 'What’s included in our airport transfer?',
    subtitle: '✈️ Airport Transfer',
    image: '/img/modalDescription/airport.webp',
    imageAlt: 'Car for airport transfer',
    ariaLabel: {
      orderButton: 'Go to the airport transfer booking form',
      orderButtonText: 'Book a transfer',
      closeButton: 'Close the modal window',
    },
    list: [
      'Driver will meet you with a sign at the terminal exit.',
      'Assistance with luggage.',
      'Flight tracking (we know if your flight is delayed).',
      'Up to 60 minutes of waiting time included.',
      'Premium-class vehicles (Wi-Fi, water, child seat upon request).',
      'Available routes: to/from Václav Havel Airport.',
      'Prices from €30.',
    ],
    text: 'Our airport transfer ensures a smooth start or finish to your journey. We monitor your flight and greet you with a name sign in the arrival zone. The driver will assist with your luggage and take you directly to your destination in a comfortable vehicle with Wi-Fi. The first hour of waiting is free of charge, so there’s no stress if your flight is delayed.',
  },

  corporate: {
    title: 'The perfect solution for your business',
    subtitle: '🧑‍💼 Corporate Transfer',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: 'Business-class car for corporate clients',
    ariaLabel: {
      orderButton: 'Go to the corporate transfer booking form',
      orderButtonText: 'Book a transfer',
      closeButton: 'Close the modal window',
    },
    list: [
      'Corporate client services.',
      'Option to sign a contract with your company.',
      'Monthly reports and invoicing.',
      'Drivers in suits, trip confidentiality.',
      'Business-class vehicles and higher.',
      'Booking for events, conferences, delegations.',
      'Route tracking via corporate dashboard.',
    ],
    text: 'We provide premium service for companies that value comfort and punctuality. Transfers between hotels, conference venues, and the airport are carried out by professional drivers experienced with VIP clients. Contracts and monthly invoicing available. Your employees will be delivered safely and on time.',
  },

  personal: {
    title: 'Your personal driver for a day, week, or trip',
    subtitle: '🚗 Personal Driver',
    image: '/img/modalDescription/personal.webp',
    imageAlt: 'Personal driver with premium-class vehicle',
    ariaLabel: {
      orderButton: 'Go to the personal driver booking form',
      orderButtonText: 'Book a driver',
      closeButton: 'Close the modal window',
    },
    list: [
      'Hourly or full-day driver rental available.',
      'City rides, stops, waiting time — all included.',
      'Premium vehicles with driver.',
      'Private rides, shopping tours, important meetings.',
      'Ideal for city guests, VIP clients, seniors.',
      'Drivers speak English/Czech.',
    ],
    text: 'Hiring a personal driver is the perfect solution for those who want mobility and freedom without the hassle. Our driver will accompany you throughout your route, no matter how complex. You can book a driver for shopping, business meetings, or even a trip out of town. Premium car, polite service, and full confidentiality — all included.',
  },

  vip: {
    title: 'Luxury and comfort at the highest level',
    subtitle: '👑 VIP & Luxury Services',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'VIP-class car ready for the trip',
    ariaLabel: {
      orderButton: 'Go to the VIP service booking form',
      orderButtonText: 'Book VIP transfer',
      closeButton: 'Close the modal window',
    },
    list: [
      'Personalized approach for every client.',
      'Top-class vehicles.',
      'Drivers in suits, experienced with VIP guests.',
      'Full confidentiality.',
      'Extras: welcome kit, mineral water, newspapers.',
      'Ideal for business meetings, diplomatic visits, weddings, and social events.',
      '24/7 support and personal manager.',
    ],
    text: 'Hiring a personal driver is the perfect solution for those who want mobility and freedom without the hassle. Our driver will accompany you throughout your route, no matter how complex. You can book a driver for shopping, business meetings, or even a trip out of town. Premium car, polite service, and full confidentiality — all included.',
  },

  tours: {
    title: 'Travel in comfort and style',
    subtitle: '🌍 Tours & Excursions',
    image: '/img/modalDescription/vip.webp',
    imageAlt: 'Vehicle for tours and excursions in Europe',
    ariaLabel: {
      orderButton: 'Go to the tour or excursion booking form',
      orderButtonText: 'Book a tour',
      closeButton: 'Close the modal window',
    },
    list: [
      'Organization of individual and group tours.',
      'Option to choose a guide or just a driver.',
      'Flexible routes across Czechia and Europe (Karlovy Vary, Vienna, Dresden, Munich, etc.).',
      'Comfortable vehicles, air conditioning, Wi-Fi, drinking water.',
      'Photo stops, shopping time, local restaurant meals.',
      'Travel insurance and support during the trip.',
      'Booking available via online form.',
    ],
    text: 'Discover Europe with us — stress-free and full of joy. We organize individual or group tours tailored to your interests. Our guides can accompany you, or you can enjoy a smooth ride with a professional driver. All routes are designed for convenience, safety, and unforgettable experiences.',
  },
};
